import React, { useState } from "react";
import ArowIndicator from "../../icons/arrowIndicator";

const TESTIMONIALS = [
  {
    id: 1,
    quote: "“League Life has been great for our jazz Families.”",
    name: "Whitli Godderidge",
    title: "VP, Family Relations & Basketball Operations, Utah Jazz",
  },
  {
    id: 2,
    quote: '"League life saved my life"',
    name: "Bre Walton",
    title: "Detroit Pistons",
  },
  {
    id: 3,
    quote:
      "“This app has been such a game changer for me lol we’ve been on the move too much to cities I’ve never been before… I need all the help I can get”",
    name: "Hailey Nance",
    title: "Cleveland Cavaliers",
  },
];

function Testimonials() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [touchStart, setTouchStart] = useState(0);
  const [touchEnd, setTouchEnd] = useState(0);

  const goToSlide = (index: number) => {
    setCurrentIndex(index);
  };

  const goToPrevious = () => {
    setCurrentIndex((prev) =>
      prev === 0 ? TESTIMONIALS.length - 1 : prev - 1
    );
  };

  const goToNext = () => {
    setCurrentIndex((prev) =>
      prev === TESTIMONIALS.length - 1 ? 0 : prev + 1
    );
  };

  const getPrevIndex = () =>
    currentIndex === 0 ? TESTIMONIALS.length - 1 : currentIndex - 1;
  const getNextIndex = () =>
    currentIndex === TESTIMONIALS.length - 1 ? 0 : currentIndex + 1;

  // Handle touch events for swipe
  const handleTouchStart = (e: React.TouchEvent) => {
    setTouchStart(e.targetTouches[0].clientX);
  };

  const handleTouchMove = (e: React.TouchEvent) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const handleTouchEnd = () => {
    if (!touchStart || !touchEnd) return;

    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > 50;
    const isRightSwipe = distance < -50;

    if (isLeftSwipe) {
      goToNext();
    }
    if (isRightSwipe) {
      goToPrevious();
    }

    // Reset
    setTouchStart(0);
    setTouchEnd(0);
  };

  return (
    <section
      className="bg-[#F1EBE2] py-16 md:py-24 overflow-hidden"
      id="testimonials"
      aria-label="Client testimonials"
    >
      <h2 className="text-center text-base font-black">Testimonials</h2>

      {/* Slider with visible prev/next */}
      <div
        className="relative flex items-center justify-center gap-4 md:gap-8 px-4 overflow-hidden touch-pan-y"
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
      >
        {/* Previous Slide Preview */}
        <div className="hidden lg:block absolute left-0 -translate-x-1/2 opacity-60 flex-shrink-0 w-[400px]">
          <article
            className="text-center px-2 min-h-[300px] flex flex-col items-center justify-center font-ppacma"
            itemScope
            itemType="https://schema.org/Review"
          >
            <blockquote
              className="text-5xl font-light leading-tight mb-4"
              itemProp="reviewBody"
            >
              {TESTIMONIALS[getPrevIndex()].quote}
            </blockquote>
            <div
              itemProp="author"
              itemScope
              itemType="https://schema.org/Person"
            >
              <h3 className="text-base font-bold mb-1" itemProp="name">
                {TESTIMONIALS[getPrevIndex()].name}
              </h3>
              <p className="text-xs text-gray-600" itemProp="jobTitle">
                {TESTIMONIALS[getPrevIndex()].title}
              </p>
            </div>
          </article>
        </div>

        {/* Current Slide */}
        <div className="flex-1 max-w-4xl mx-auto">
          <article
            className="text-center px-4 md:px-8 min-h-[300px] flex flex-col items-center justify-center"
            itemScope
            itemType="https://schema.org/Review"
          >
            <blockquote
              className="text-4xl md:text-[56px] font-light leading-[120%] mb-8 font-ppacma max-w-[700px]"
              itemProp="reviewBody"
            >
              {TESTIMONIALS[currentIndex].quote}
            </blockquote>
            <div
              itemProp="author"
              itemScope
              itemType="https://schema.org/Person"
            >
              <h3
                className="text-[24px] md:text-2xl font-bold mb-2"
                itemProp="name"
              >
                {TESTIMONIALS[currentIndex].name}
              </h3>
              <p
                className="text-[20px] md:text-lg text-gray-600"
                itemProp="jobTitle"
              >
                {TESTIMONIALS[currentIndex].title}
              </p>
            </div>
          </article>

          {/* Navigation */}
          <div className="flex items-center justify-center gap-2 mt-12">
            {/* Previous Arrow */}
            <button
              onClick={goToPrevious}
              className="text-3xl hover:opacity-70 transition-opacity w-10 h-10 flex items-center justify-center"
              aria-label="Previous testimonial"
            >
              <ArowIndicator className="rotate-180" />
            </button>

            {/* Dot Indicators */}
            <div className="flex gap-3">
              {TESTIMONIALS.map((_, index) => (
                <button
                  key={index}
                  onClick={() => goToSlide(index)}
                  className={`w-3 h-3 rounded-full transition-all ${
                    index === currentIndex
                      ? "bg-[#817B50] w-8"
                      : "bg-[#B7B49D] hover:bg-gray-600"
                  }`}
                  aria-label={`Go to testimonial ${index + 1}`}
                />
              ))}
            </div>

            {/* Next Arrow */}
            <button
              onClick={goToNext}
              className="text-3xl hover:opacity-70 transition-opacity w-10 h-10 flex items-center justify-center"
              aria-label="Next testimonial"
            >
              <ArowIndicator />
            </button>
          </div>
        </div>

        {/* Next Slide Preview */}
        <div className="absolute right-0 translate-x-1/2 hidden lg:block opacity-60 flex-shrink-0 w-[400px]">
          <article
            className="text-center px-2 min-h-[300px] flex flex-col items-center justify-center font-ppacma"
            itemScope
            itemType="https://schema.org/Review"
          >
            <blockquote
              className="text-5xl font-light leading-[120%] mb-4"
              itemProp="reviewBody"
            >
              {TESTIMONIALS[getNextIndex()].quote}
            </blockquote>
            <div
              itemProp="author"
              itemScope
              itemType="https://schema.org/Person"
            >
              <h3 className="text-base font-bold mb-1" itemProp="name">
                {TESTIMONIALS[getNextIndex()].name}
              </h3>
              <p className="text-xs text-gray-600" itemProp="jobTitle">
                {TESTIMONIALS[getNextIndex()].title}
              </p>
            </div>
          </article>
        </div>
      </div>
    </section>
  );
}

export { Testimonials };
